import {
  GetUnacceptedBatchesResponse,
  SummarizeMinimizedResponse,
} from '@/dashboard/services/dashboardApi';
import { DashboardRowPeriodDetails } from '@/dashboard/utils/DashboardCalculations/dashboardCalculations.utils';
import PeriodCalculator from '@/dashboard/utils/DashboardCalculations/PeriodCalculator';

class DashboardCalculator {
  calculations: DashboardRowPeriodDetails = {};
  counts: SummarizeMinimizedResponse;
  unacceptedBatches: GetUnacceptedBatchesResponse;

  constructor(counts: SummarizeMinimizedResponse, unacceptedBatches: GetUnacceptedBatchesResponse) {
    this.counts = counts;
    this.unacceptedBatches = unacceptedBatches;
    this.forEachBatch();
  }

  forEachBatch() {
    for (const period in this.counts) {
      const batch = new PeriodCalculator(period, this.counts[period], this.unacceptedBatches);
      batch.getPeriodLabel();
      batch.getButtonStatus();
      batch.calculateErrors();
      batch.calculateUnsubmitted();
      batch.buildBands();

      this.calculations[period] = batch.getPeriodCalculations();
    }
  }

  getCalculations() {
    return this.calculations;
  }
}

export default DashboardCalculator;
